import React from "react";
import styled from "styled-components";
import { PostData } from "../Functions/SendingData";
import { goodpageText } from "../../Lang/fa/Goodpage";
import { baseText } from "../../Lang/fa/UserPannel/UserPannel";
import GLike from '../../assets/newSvg/like-g.svg';
import DisLike from '../../assets/newSvg/dislike-g.svg';
import { TextInputWTitle } from "../NewComp/SmallComps/TextInputWTitle";
import close from '../../assets/newSvg/close-circle.svg';

const StyleForm = styled.form`
    background-color:var(--body-2);
    border-radius: var(--border-radius);
    padding: 1.5rem 0;
    display: flex;
    width: 100%;
    flex-direction: column;
    color: var(--text-5);
    .top-pop{
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        align-items: center;
        position: relative;
        padding: 0 calc(50% - 3rem) 1.5rem 1.5rem;
        border-bottom: var(--border-style-2);
        .title{
            font-size: 1rem;
            font-weight: 400;
            text-align:start;
        }
        .close{
            cursor: pointer;
        }

    }
    .part{
        font-weight: 500;
        font-size: 0.75rem;
    }
    .goodcm , .suggest{
        padding: 1rem 1.5rem;
        width: calc(100% - 3rem);
        position: relative;
        display: flex;
    }
    .goodcm{
        background:none;
        margin: 1rem 0;
        flex-direction: row;
        align-items: center;
        .image{
            width: 5rem;
            height: 5rem;
            border: none;
        }
        .name{
            font-size: var(--fs-good-comment-text);
            font-weight: 500;
            color: var(--text-2);
            margin-right: 3rem;
        }
    }
    .rate{
        padding: 0.5rem  1.5rem 0;
        width: calc(100% - 3rem);
        text-align:center;
        display: flex;
        flex-direction: column;
        justify-content: center;
        .field{
            width:100%;
            margin: 1rem 0 0;
            padding: 0.5rem 0 0;
            .score{
                width: 100%;
                margin: 0;
            }
        }   
        .dotte-row{
            display: flex;
            flex-direction: row;
            justify-content: space-between;
            width:100%;
            border-bottom: var(--border-style-2);
            padding: 0.5rem 0 1rem;
            .dotte{
                border-radius: var(--border-radius-7);
                background: var(--gray-3);
                width: 0.5rem;
                height: 0.5rem;
                aspect-ratio: 1;
            }
            .sh-score{
                display: flex;
                border-radius: 0;
                background: none;
                color: var(--primary-10) ;
                font-size: 0.75rem;
                font-weight: 500;
                width: auto;
                height: auto;
                justify-content: center;
                align-items: center;
            }
        } 
        input[type="range"] {
            -webkit-appearance: none;
            width: 100%;
            /* direction: ltr; */
        }
        input[type="range"]:focus {
            outline: none;
        }
        input[type="range"]::-webkit-slider-runnable-track {
            width: 100%;
            height: 0.5rem;
            cursor: pointer;
            background:var(--gray-3);
            border-radius: 25px;
        }
        input[type="range"]::-webkit-slider-thumb {
            height: 1rem;
            width: 1rem;
            aspect-ratio: 1;
            border-radius: 50px;
            background: var(--primary-10);
            cursor: pointer;
            margin-top: -0.25rem;
            -webkit-appearance: none;
        }
        input[type="range"]:focus::-webkit-slider-runnable-track {
            background:var(--gray-3);
        }
        input[type="range"]::-moz-range-track {
            width: 100%;
            height: 1rem;
            cursor: pointer;
            animate: 0.2s;
            background: var(--gray-3);
            border-radius: 25px;
        }
        input[type="range"]::-moz-range-thumb {
            height: 1rem;
            width: 1rem;
            border-radius: 50px;
            background: var(--primary-10);
            cursor: pointer;
        }
        input[type="range"]::-ms-track {
            width: 100%;
            height: 12.8px;
            cursor: pointer;
            animate: 0.2s;
            background:var(--gray-3);
        }
        input[type="range"]::-ms-fill-lower {
            background: var(--gray-3);
            border-radius: 50px;
        }
        input[type="range"]::-ms-fill-upper {
            background: var(--gray-3);
            border-radius: 50px;
        }
        input[type="range"]::-ms-thumb {
            height: 1rem;
            width: 1rem;
            border-radius: 50px;
            background: var(--primary-10);
            cursor: pointer;
        }
        input[type="range"]:focus::-ms-fill-lower {
            background: var(--gray-3);
        }
        input[type="range"]:focus::-ms-fill-upper {
            background: var(--gray-3);
        }

    }
    .comment{
        padding: 0 1.5rem;
        width: calc(100% - 3rem);
        text-align:start;
        .cmttext{
            height: calc(100% - 4rem);
            width: calc(100% - 3rem);
            resize: none;
            position: relative;
            background-color: var(--light-bg);
            border-radius: var(--border-radius-6);  
            border: none;
            margin-top: 1rem;
            padding: 1rem;
            outline-color: var(--o-prime-3);
            font-size: var(--fs-good-comment-input);
        }
    }
    .suggest{
        display: flex;
        flex-direction: row-reverse;
        justify-content: space-between;
        align-items: center;
        text-align: center;
        .option{
            display: flex;
            flex-direction: row;
            align-items: center;
            text-align: center;
            font-weight: 500;
            font-size: 0.75rem;
            border: var(--border-style-2);
            border-radius: var(--border-radius-9);
            padding: 1rem;
            .op-svg{
                margin-left: 0.2rem;
            }
        }
        .check{
            border-color: var(--primary-8);
        }
    }
    .unknown{
        padding: 0.5rem 1.5rem;
        width: calc(100% - 3rem);
        display: flex;
        align-items: center;
        font-size: 0.75rem;
        font-weight: 500;
        color: var(--text-9);
        border-bottom: var(--border-style-2);
    }
    .buttons{
        padding: 1rem 1.5rem 0;
        width: calc(100% - 3rem);
        display: flex;
        flex-direction: row;
        justify-content: center;
        .cmt{
            border: none;
            border-radius: var(--border-radius-9 );
            cursor: pointer;
            text-align: center;
            color: var(--text-3);
            background-color: var(--primary-5);
            width: 100%;
            padding: 1rem 0;
        }
        
    }
    input[type="checkbox"]{
        width: 1.2em;
        height: 1.2em;
        background-color: white;
        vertical-align: middle;
        border: 1px solid var(--border-color);
        appearance: none;
        -webkit-appearance: none;
        cursor: pointer;
    }
    input[type="checkbox"]:checked {
    background-color: var(--body-2);
    }
    input[type="checkbox"]:checked:after {
    content: "";
    background-color: var(--primary-2);
    width: 0.8em;
    height: 0.8em;
    display: flex;
    margin: 0.12rem;
    }
    input{
        :out-of-range{
            border-color: var(--secondry-1)
        }
    }
    @media screen and (max-width:850px){
       
        .goodcm , .rate , .comment , .suggest{
            margin:0.5rem 0;
            .text-field{
                width: calc(100% - 1.8rem)
            }
            .image{
                width: 4rem;
                height: 4rem;
            }
            .cmttext{
                height: 60%;
                margin-top: 0.2rem;
            }
            .field {
                padding: 0 1rem;
                margin-top: 0.2rem;
                align-items: center;
                flex-direction: column;
                width: calc(100% - 2rem);
                .text{
                    display: flex;
                    flex-direction: row;
                    align-items: center;
                    margin-bottom: 0.5rem;
                    white-space: nowrap;
                    .score{
                        width: 6rem;
                        margin-right: 0.5rem;
                        padding: 0.2rem;
                        width: 6rem;
                    }
                }
            }
            .dotte-row{
                padding: 1rem;
                width: calc(100% - 2rem);
            }
        }
        .goodcm{
            padding: 0.5rem 1rem;
            width: calc(100% - 2rem);
        }
        .suggest{
            flex-direction: column-reverse;
            justify-content: flex-start;;
            white-space: nowrap;

            .buy{
                text-align: start;
            }
            .option{
                margin: 0.5rem;
                flex-grow: 1;
                padding: 0.5rem 0;
                width: 100%;
                text-align:center;
                justify-content:center
            }
        }
        .unknown{
            margin: 0.5rem 0;
        }
        .buttons .cmt{
            padding: 0.5rem 1rem;
            width: calc(100% - 2rem );
            font-size: var(--fs-good-comment-input);
            font-weight: 500;
        }
        
    }
`;
let radio =[baseText.idk,baseText.no,baseText.yes]
class GoodCommentForm extends React.Component{
    constructor(props){
        super(props);
        this.add = React.createRef()
        this.state={   
            objectDataGood:[],
            objectData:[],
            addNewComm:'',
            add:'', 
            user:JSON.parse(localStorage.getItem("userdata")),
            addCm:{},
            shgcode:'',
            gcode:'',
            dots:[0,1,2,3,4,5]
        }
    }

    componentDidMount () {
        let comment={
            desc:'',
            gname:'',
            score: '',
            user:'',
            recomend:''
        }
        this.setState({
            addCm: comment
        })
        this.getData();
        if(this.props.match.url.split('/')[1] === 'good'){
            window.scrollTo({
                top: 0,
                behavior:"smooth"
            })
        }
    }
    getData = () => {
        let formData = new FormData();
        formData.append('api_token',this.state.user.token);
        formData.append('U_CODE',this.state.user.usercode);
        formData.append('G_CODE',this.props.gcode);
        formData.append('SH_G_CODE',this.props.shgcode);
        PostData(process.env.REACT_APP_API + '/api/v1/goods/user_goods_comment/last_buy_for_comment',formData, this, this.Proccess);
    }
    Proccess(obj, data){
        let response = JSON.parse(data);
        if (response.status === 'success') {
            obj.setState({
                response: 'success',
                objectDataGood: response.data[0],
                sending: false,
            });
        } else if (response.status === 'error') {
            obj.setState({
                response: 'success',
                sending: false
            });
        } else if (response.status === 'error-no-internet') {
            obj.setState({
                sending: false
            });
        }
    }
    SendComm=()=>{
        let cmd = this.state.addCm;
        let formData = new FormData();
        formData.append("api_token", this.state.user.token);
        formData.append("U_CODE", this.state.user.usercode);
        formData.append("SH_G_CODE", this.props.shgcode);
        formData.append("U_LNAME", this.state.user.U_LNAME);
        formData.append("U_G_COMM_DESC", cmd.desc);
        formData.append("U_G_COMM_USER_RECOMMAND", cmd.recomend);
        formData.append("U_G_COMM_USER_VIEW", this.showUser(cmd.user));
        formData.append("U_G_COMM_GOODS_SCORE", (cmd.score / 20));
        formData.append("U_G_COMM_TYPE", 0);
        this.setState({
            sending: true,
        });
        PostData(
        process.env.REACT_APP_API + "/api/v1/goods/user_goods_comment/insert",
        formData,
        this,
        this.SendProccess
        );
    }
    SendProccess(obj, data){
        let response = JSON.parse(data);
        if (response.status === 'success') {    
            obj.setState({
                response: 'success',
                objectData: response.data,
                sending: false, 
            });
            obj.props.close()
        } else if (response.status === 'error') {
            obj.setState({
                response: 'success',
                sending: false
            });
        } else if (response.status === 'error-no-internet') {
            obj.setState({
                sending: false
            });
        }
    }
    changeForm=(event)=>{
        let getData = this.state.addCm;
        switch (event.target.name) {
            case "U_G_COMM_DESC":
                getData.desc = event.target.value;
                break
            case "U_G_COMM_USER_VIEW":
                if(getData.user){
                    getData.user = 0
                }else{
                    getData.user = 1
                }
                break;
            case "U_G_COMM_GOODS_SCORE":
                getData.score = event.target.value;
                break;
            default:
                break;
        }
        this.setState({
            addCm: getData,
          });
    }
    recomend=(e)=>{
        let rec = this.state.addCm
        if(e === 0 ){
            rec.recomend =  0
        }else if( e === 1){
            rec.recomend = 2
        }else if(e === 2){
            rec.recomend = 1
        }
        this.setState({
            addCm: rec,
            rec: e
        });
    }
    showUser(e){
        if(e){
            return 1
        }else{
            return 0
        }
    }
    optionSvg(index){
        switch(index){
            case 2:
                return <img alt='GLike' src={GLike} className="op-svg"/>
            case 1:
                return <img alt='DisLike' src={DisLike} className="op-svg"/>
            case 0:
                return '';
            default:
                break
        }
    }
    dottes=(score)=>{
        if(!score){
            score = 100
            for( let i = 100 ; i === 0 ; i / 2){
                score = i
            }
        }
        let dt = this.state.dots.map(( d )=>{
            if(parseInt(d)  === parseInt(score / 20)){
                return <span className="dotte sh-score"> {d} </span>
            }else{
                return <span className="dotte" ></span>
            }
       })
       return dt
    }
    render(){
        return(
            <StyleForm ref={this.add} 
                className={(this.props.match.url.split('/')[1] === 'good') ? '': 'usercm'}
            >
                <div className="top-pop">
                    <span className="title">{baseText.addnewComment}</span>
                    <img alt='close' src={close} className="close" onClick={()=>this.props.close()}/>
                </div>
                <div className="rate">
                    <span className="part">{baseText.rate}</span>
                    <div className="field">
                        <input type='range' max={'100'} min={'0'} step={'20'} required={true} value={this.state.addCm.score ? this.state.addCm.score : 100} name='U_G_COMM_GOODS_SCORE' onChange={(e)=>this.changeForm(e)} className="score"  />
                    </div>
                    <div className="dotte-row">
                        {this.dottes(this.state.addCm.score)}
                    </div>
                </div>
                <div className="suggest" >
                   { radio.map((rd , index)=>{
                       return(
                            <div className={"option " + (this.state.rec=== index  ? 'check' : '')} name='U_G_COMM_USER_RECOMMAND' key={index}  onClick={()=>this.recomend(index)}>
                                {this.optionSvg(index)}
                                <label htmlFor={index} >{rd}</label>
                            </div>
                        )
                   })}
                </div>
                <div className="comment">
                    <TextInputWTitle
                     error='' 
                     defaultValue={this.state.addCm.desc} 
                     name={'U_G_COMM_DESC'} 
                     title={goodpageText.Commenttext} 
                     onchange={(e)=>this.changeForm(e)} 
                     className="cmttext"
                     />
                </div>
                <div className="unknown">
                    <input 
                        type='checkbox' 
                        name="U_G_COMM_USER_VIEW" 
                        onChange={(e)=>this.changeForm(e)} 
                        checked={this.showUser(this.state.addCm.user)}
                    />
                    <label>{goodpageText.unknown}</label>
                </div>
                <div className="buttons">
                    <div className="cmt" 
                        onClick={this.SendComm}
                    >{goodpageText.done}</div>
                </div>
            </StyleForm>
        )
    }
}
export default GoodCommentForm;